import { fetchCVApplicationEndPoint } from "../configuration";
import axiosInstance from "../global/axiosInterceptor";

export const fetchCVApps = async (activeSession) => {
  try {
    const cvAppRsp = await axiosInstance.post(fetchCVApplicationEndPoint(), {
      accountname: activeSession.accountId,
      filter: {
        $expand: "template",
      },
    });
    const data = cvAppRsp.data;
    let filteredCVAppList = data.filter(
      (cvApp) => cvApp.type !== "unknown" && cvApp.type
    );
    return filteredCVAppList.sort((a, b) => a?.name?.localeCompare(b?.name));
  } catch (error) {
    console.error("Error fetching CVApps:", error);
  }
};
